import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Overview from "../components/landing/Overview";
import Collection from "../components/landing/Collection";
import FloorPlans from "../components/landing/FloorPlans";
import Investment from "../components/landing/Investment";
import PaymentPlan from "../components/landing/PaymentPlan";
import Location from "../components/landing/Location";
import IslandLifestyle from "../components/landing/IslandLifestyle";
import Process from "../components/landing/Process";
import WhyUs from "../components/landing/WhyUs";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import { BRAND } from "../data/project";

export default function Landing() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    document.title =
      "Hudayriyat Golf Estates | Modon | PK Properties Private Client";

    const onScroll = () => {
      // Reveal floating WhatsApp once user has scrolled past 80% of viewport (past hero)
      setShowFloatingCTA(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="bg-[#F4F2EC] text-[#1A3626] overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Overview />
        <Collection />
        <FloorPlans />
        <Investment />
        <PaymentPlan />
        <Location />
        <IslandLifestyle />
        <Process />
        <WhyUs />
        <Contact />
      </main>
      <Footer />

      {/* Floating WhatsApp — appears after hero only, sized to avoid stats overlap on mobile */}
      <a
        href={`https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(
          "Hi Carlton, I'd like to enquire about Hudayriyat Golf Estates."
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Contact via WhatsApp"
        className={`fixed bottom-5 left-5 md:bottom-6 md:left-6 z-40 bg-[#1A3626] text-[#F4F2EC] w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center shadow-xl hover:bg-[#234734] border border-[#B3906A]/40 transition-all duration-500 ${
          showFloatingCTA
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-6 pointer-events-none"
        }`}
      >
        <MessageCircle className="w-5 h-5 md:w-6 md:h-6" strokeWidth={1.5} />
      </a>
    </div>
  );
}
